import { FerramentaVideoService } from 'core/http/service/ferramentaVideo/FerramentaVideo.service';
import { IFVContainer } from 'pages/ferramentaVideo/interfaces/FVContainer.interface';
import { useQuery, useQueryClient } from 'react-query';

const service = new FerramentaVideoService();

const fetchFerramenta = async (urlFerramenta: string): Promise<any> => {
    const response = await service.getFerramenta(urlFerramenta);
    return response.data;
};

export const useFerramentaVideo = (urlFerramenta: string) => {

    const listFerramenta = useQuery<IFVContainer>(['ferramentaVideoPublic', urlFerramenta], async ({ queryKey }) => {
        const [, urlFerramenta] = queryKey as [string, string];

        const data = await fetchFerramenta(urlFerramenta);

        if(data?.status === 404){
            return null;
        }
        
        return data;
    });

    return { listFerramenta };
};
